/**
 * Copyright (c) 2018-present, Tomaruba, Inc.
 * All rights reserved.
 */
import { Record } from 'immutable'

const _SegmentValueState = {
  id: null,
  name: '',
  priority: null,
  status: 'show'
}

class SegmentValueState extends Record(_SegmentValueState) {
  toRequestBody() {
    return {
      id: this.id,
      name: this.name,
      priority: this.priority,
      status: this.status
    }
  }
}

export { SegmentValueState }
